import styled from '@emotion/styled';
import { Link } from 'react-router';
import Icons from '../images/Icons';
import { MixinFocusVisible } from '../structure/DefaultStyles';

export const RowWrapper = styled.div`
    display: flex;
    border-bottom-width: 1px;
    border-style: solid;
    flex-basis: 100%;
    border-color: ${(props) => props.theme.color.border};
`;

export const RowWrapperNoBorder = styled.div``;

export const RowContent = styled.span`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const RowChildrenContainer = styled.div`
    margin-top: 0.5rem;
`;

export const RowEndIcon = styled(Icons)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const RowStartIcon = styled(Icons)`
    margin-top: 0.4rem;
`;

export const RowGroupWrapper = styled.div`
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
`;

export const ActionRowBase = styled.div<{
    disabled: boolean;
}>`
    flex-grow: 1;
    gap: 0.5rem;
    display: flex;
    flex-direction: row;
    padding: 1rem;
    text-align: left;
    text-decoration: none;
    border: none;
    font-weight: inherit;
    background-color: ${(props) => props.theme.color.background};
    transition:
        background-color 0.2s ease-in-out,
        border-color 0.2s ease-in-out;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    &:hover {
        background-color: ${(props) => (props.disabled ? 'transparent' : props.theme.color.cardHover)};
    }
    color: ${(props) => props.theme.color.text};
    ${MixinFocusVisible};
`;

export const LinkRow = styled(ActionRowBase.withComponent('a'))`
    &:hover {
        color: ${(props) => (props.disabled ? props.theme.color.textBody : props.theme.color.link)};
        cursor: pointer;
    }
`;
export const ButtonRow = styled(ActionRowBase.withComponent('button'))`
    &:hover {
        color: ${(props) => (props.disabled ? props.theme.color.textBody : props.theme.color.link)};
        cursor: pointer;
    }
`;
export const InternalLinkRow = styled(ActionRowBase.withComponent(Link))`
    background-color: ${(props) => props.theme.color.cardHover};
    margin-top: 0.5rem;
    border-radius: 10px;
    border: 1px solid ${(props) => props.theme.color.border};
    &:hover {
        background-color: ${(props) => props.theme.color.card};
        cursor: pointer;
    }
`;

export const ButtonRowFlex = styled.div`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    & > * {
        flex: 1;
    }
`;
